"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrepareData = void 0;
var react_1 = require("react");
var _EXPORTS_1 = require("../../../../utils/_EXPORTS");
var getTotalCount_1 = require("../../../../utils/getTotalCount");
var usePrepareData = function (_a) {
    var _data = _a._data, labelPath = _a.labelPath, valuePath = _a.valuePath, tooltipLabelsMapping = _a.tooltipLabelsMapping, tooltipLabelsPath = _a.tooltipLabelsPath, isBreakdown = _a.isBreakdown, showPercent = _a.showPercent, summarizeAfterIdx = _a.summarizeAfterIdx;
    return (0, react_1.useMemo)(function () {
        var finalData = __spreadArray([], _data, true);
        var totalCount = !isBreakdown
            ? (0, getTotalCount_1.getTotalCount)({ data: finalData, countPath: valuePath })
            : finalData.map(function (d) {
                var valueSum = valuePath
                    .map(function (path) { return (0, _EXPORTS_1.getVal)(d, path) || 0; }) // fallback to 0, cuz sometimes backend systems return 'undefined' if the count of data against a field is non-existent / zero
                    .reduce(function (acc, curr) { return acc + curr; }, 0);
                return valueSum;
            });
        finalData = finalData.map(function (d, index) {
            if (!isBreakdown) {
                var count = (0, _EXPORTS_1.getVal)(d, valuePath) || 0; // fallback to 0, cuz sometimes backend systems return 'undefined' if the count of data against a field is non-existent / zero
                return {
                    labels: __assign(__assign({}, (showPercent
                        ? { percentage: (0, _EXPORTS_1.getPercentage)(count, totalCount) }
                        : {})), { count: count, name: (0, _EXPORTS_1.getVal)(d, labelPath) }),
                };
            }
            return valuePath.map(function (path, i) {
                var count = (0, _EXPORTS_1.getVal)(d, path) || 0;
                return {
                    labels: __assign(__assign({}, (showPercent
                        ? { percentage: (0, _EXPORTS_1.getPercentage)(count, totalCount[index]) }
                        : {})), { count: count, tooltipLabel: tooltipLabelsPath
                            ? tooltipLabelsPath[i]
                                ? (0, _EXPORTS_1.getVal)(d, tooltipLabelsPath[i]) || tooltipLabelsPath[i]
                                : path
                            : (tooltipLabelsMapping === null || tooltipLabelsMapping === void 0 ? void 0 : tooltipLabelsMapping[path]) || path, name: (0, _EXPORTS_1.getVal)(d, labelPath) }),
                };
            });
        });
        // Sort by total value
        finalData.sort(function (a, b) {
            if (!isBreakdown) {
                return b.labels.count - a.labels.count;
            }
            else {
                var bTotal = b
                    .map(function (bItem) { return bItem.labels.count; })
                    .reduce(function (acc, curr) { return acc + curr; }, 0);
                var aTotal = a
                    .map(function (aItem) { return aItem.labels.count; })
                    .reduce(function (acc, curr) { return acc + curr; }, 0);
                return bTotal - aTotal;
            }
        });
        finalData = isBreakdown
            ? finalData.map(function (d, i) {
                return d.map(function (dd, ii) { return (__assign(__assign({}, dd), { labels: __assign(__assign({}, dd.labels), { dataIndex: i }) })); });
            })
            : finalData.map(function (d, i) { return (__assign(__assign({}, d), { labels: __assign(__assign({}, d.labels), { dataIndex: i }) })); });
        var mainData = !isBreakdown
            ? finalData.filter(function (_, i) { return i <= summarizeAfterIdx; })
            : finalData;
        var convertDataToSummrizeIntoBreakdownFormat = function (data) {
            var reshaped = data.map(function (d, i) { return (__assign(__assign({}, d), { labels: __assign(__assign({}, d.labels), { name: "Others", tooltipLabel: d.labels.name, dataIndex: i }) })); });
            return [reshaped];
        };
        var dataToSummarize = !isBreakdown
            ? convertDataToSummrizeIntoBreakdownFormat(finalData.filter(function (_, i) { return i > summarizeAfterIdx; }))
            : undefined;
        var calcDataMaxValue = function (mainData, dataToSummarize, isBreakdown) {
            //now if there is no data to summarize its simple. take the first element and get its count (for !isBreakdown) or accumulate to count for first element (isBreakdown)
            // with dataToSummarize, its interesting, because a summarized bar is a 'summation' of everything it is summarizing. sooo.. the summation (and not the individual values) should be taken into consideration while figuring out maxValue
            if (!dataToSummarize) {
                return !isBreakdown
                    ? mainData[0].labels.count
                    : mainData[0].reduce(function (acc, b) { return acc + b.labels.count; }, 0);
            }
            else {
                var totalCountOfSummarizedData = dataToSummarize[0].reduce(function (acc, b) { return acc + b.labels.count; }, 0);
                var maxCountFromMainData = !isBreakdown
                    ? mainData[0].labels.count
                    : mainData[0].reduce(function (acc, b) { return acc + b.labels.count; }, 0);
                return maxCountFromMainData > totalCountOfSummarizedData
                    ? maxCountFromMainData
                    : totalCountOfSummarizedData;
            }
        };
        return {
            data: mainData,
            dataMaxValue: calcDataMaxValue(mainData, dataToSummarize, isBreakdown),
            dataToSummarize: dataToSummarize,
        };
    }, [_data, labelPath, valuePath, isBreakdown, showPercent]);
};
exports.usePrepareData = usePrepareData;
